<template>
	<el-dialog :close-on-click-modal="false" :title="dlgTitle" :visible.sync="dlgVisiable" destroy-on-close @closed="handleClose">
		<div>
			<el-row type="flex">
				<el-input placeholder="昵称，姓、名、医院、职务、头衔、擅长" v-model="searchUserValue"
					@keyup.enter.native="getSearchUserList"></el-input>
				<el-button size="small" type="primary" icon="el-icon-search" @click="getSearchUserList"></el-button>
			</el-row>

		</div>
		<div>
			<el-table v-loading="searchUserDlgLoading" :data="searchUserList">
				<el-table-column prop="userID" label="ID" align="center" />
				<el-table-column label="头像" align="center">
					<template #default="prop">
						<el-avatar :key="prop.row.avatar" :src="config.RESOURCES+prop.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" />
				<el-table-column label="姓名" align="center">
					<template #default="prop">
						{{prop.row.firstName}}{{prop.row.lastName}}
					</template>
				</el-table-column>
				<el-table-column prop="mobilePhone" label="手机号" align="center" />
				<el-table-column align="center" label="操作">
					<template #default="prop">
						<slot name="default" :entity="prop.row"></slot>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :total="searchUserDlgTotal" hide-on-single-page background :page-size="searchUserDlgPageSize"
				:current-page="searchUserDlgCurrentPage" @current-change="searchDlgCurrentChange"></el-pagination>
		</div>

	</el-dialog>
</template>

<script>
	
	import {
		isVaild
	} from "@/utils/validate"
	
	import {
		getAllUserList,
	} from "@/api/userManagement";
	
	import {ref} from 'vue'

	
	export default {
		data() {
			return {
				searchUserValue: "",
				searchUserList: [],
				searchUserDlgLoading: false,
				searchUserDlgTotal: 0,
				searchUserDlgCurrentPage: 1,
				searchUserDlgPageSize: 5,
				dlgVisiable:this.visiable
			}
		},
		watch: {
			visiable(newValue, oldValue) {
				this.dlgVisiable = newValue;
			}
		},
		props: {
			dlgTitle: {
				type: String,
			},
			visiable: {
				type: Boolean,
			},
		},
		emits: ["dlg-close"],
		methods: {
			handleClose(){
				this.$emit('dlg-close')
			},
			/**
			 * 搜索用户，用于专家
			 */
			getSearchUserList() {
				if (!isVaild(this.searchUserValue)) {
					this.searchUserList = []
					this.searchUserDlgTotal = 0
					this.searchUserDlgLoading = false
					return
				}
				this.searchUserDlgLoading = true;
				const params = {
					sortName: "",
					sortOrder: "",
					pageNumber: this.searchUserDlgCurrentPage,
					pageSize: this.searchUserDlgPageSize,
					userDataType: "2",
					keyWord: this.searchUserValue,
				};
				getAllUserList(params).then((res) => {
					this.searchUserList = res.data.rows;
					this.searchUserDlgTotal = res.data.total;
					this.searchUserDlgLoading = false
				});
			},
			/**
			 * 搜索用户对话框分页
			 * @param {Object} currentPage
			 */
			searchDlgCurrentChange(currentPage) {
				this.searchUserDlgCurrentPage = currentPage;
				this.getSearchUserList()
			},
		},
		
	}
</script>

<style>
</style>
